import Box from '@mui/system/Box';
import Icon from 'components/system/Icon';
import colors from 'styles/colors';
import {
  memo, useEffect, useState, useRef,
} from 'react';

const styles = {
  thumbnail: {
    width: '100%',
    height: '160px',
    minHeight: '160px',
    objectFit: 'cover',
  },
  defaultThumbnail: {
    width: '100%',
    height: '160px',
    minHeight: '160px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: colors.linear_gradient,
  },
};

const CompetitionThumbnail = ({ thumbnail, name }) => {
  const [imageError, setImageError] = useState(false);
  const timeoutRef = useRef(null);
  const timeoutReached = useRef(false); // ✅ Store timeout state without causing re-renders

  useEffect(() => {
    if (!thumbnail) return undefined;

    setImageError(false);
    timeoutReached.current = false; // Reset timeout flag

    timeoutRef.current = setTimeout(() => {
      timeoutReached.current = true;
    }, 5000);

    return () => clearTimeout(timeoutRef.current);
  }, [thumbnail]);

  const handleImageLoad = () => {
    clearTimeout(timeoutRef.current);
    timeoutReached.current = false;
  };

  const showFallback = !thumbnail || imageError || timeoutReached.current;

  return showFallback ? (
    <Box sx={styles.defaultThumbnail}>
      <Icon name="competitions" color={colors.text.primary} size={54} />
    </Box>
  ) : (
    <Box
      component="img"
      key={thumbnail} // ✅ Ensures React keeps the same image element
      src={thumbnail}
      alt={name || 'thumbnail'}
      sx={styles.thumbnail}
      onError={() => setImageError(true)}
      onLoad={handleImageLoad}
    />
  );
};

// ✅ Ensuring re-renders happen only when thumbnail actually changes
export default memo(
  CompetitionThumbnail,
  (prevProps, nextProps) => prevProps.thumbnail === nextProps.thumbnail,
);
